import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import 'dayjs/locale/ky';
import relativeTime from 'dayjs/plugin/relativeTime';
import isToday from 'dayjs/plugin/isToday';
import isYesterday from 'dayjs/plugin/isYesterday';

// Extend dayjs with plugins
dayjs.extend(relativeTime);
dayjs.extend(isToday);
dayjs.extend(isYesterday);

export const formatDate = (dateString, language = 'ru', format = 'D MMMM YYYY') => {
  if (!dateString) return '';
  const date = dayjs(dateString);
  if (!date.isValid()) return '';
  
  // Map our language codes to dayjs locales if needed
  // assuming 'ky' and 'ru' are correct for dayjs
  const locale = language === 'ky' ? 'ky' : 'ru';
  
  return date.locale(locale).format(format);
};

export const formatNewsDate = (dateString, language = 'ru', t = (key) => key) => {
  if (!dateString) return '';
  const date = dayjs(dateString);
  if (!date.isValid()) return '';
  
  const locale = language === 'ky' ? 'ky' : 'ru';
  const d = date.locale(locale);

  if (d.isToday()) {
    return t('today');
  }
  if (d.isYesterday()) {
    return t('yesterday');
  }
  
  return d.format('D MMMM YYYY');
};

export const formatDateTime = (dateString, language = 'ru') => {
    return formatDate(dateString, language, 'D MMMM YYYY, HH:mm');
};
